import Router from "@al/next/router";

// 通用调整方法
const linkTo = (link: string, isReplace = false): void => {
  link = link.trim();
  // 都使用Router来跳转
  Router[isReplace ? "replace" : "push"](link);
};

export default linkTo;
